@if (recap()) {
  <div class="flex-container w100 gap-12">

    <!-- Refonte prépa physique : ventilation 4 segments en en-tête.
         Affichée pour le 1er lot (cas usuel : un lot unique sur la fiche) -->
    @if ((lots() ?? []).length === 1 && lots()[0]?.id) {
      <vl-lot-prepa-summary
        [lotId]="lots()[0]!.id!"
        [unite]="unite()"/>
    }

    <div class="text-line justify-between">
      <div class="caption">
        {{ 'stock.total' | trans }}
      </div>

      <div class="text-line">
        <div class="body-2">
          {{ displayTotal() | numberSig }}
        </div>
        <div class="caption">{{ unite() }}</div>
      </div>
    </div>

    @if (valeurUnitairePonderee() !== null) {
      <div class="text-line justify-between">
        <div class="caption">
          {{ 'data.valeurUnitairePonderee' | trans }}
        </div>
        <div class="body-2">
          {{ valeurUnitairePonderee() | number:'1.2-2' }} €
        </div>
      </div>

      <div class="text-line justify-between">
        <div class="caption">
          {{ 'data.valeurTotale' | trans }}
        </div>
        <div class="body-2">
          {{ valeurTotaleStock() | number:'1.2-2' }} €
        </div>
      </div>
    }

    <!-- Réservations pré-préparation : lignes alignées comme Stock total -->
    @if (reserveValideeTotal() > 0 || reserveDraftTotal() > 0) {
      <div class="text-line justify-between">
        <div class="caption">
          Stock disponible
        </div>
        <div class="text-line">
          <div class="body-2 on-valid">
            <strong>{{ dispoTotal() | numberSig }}</strong>
          </div>
          <div class="caption">{{ unite() }}</div>
        </div>
      </div>

      @if (reserveValideeTotal() > 0) {
        <div class="text-line justify-between">
          <div class="caption on-background-alt">
            Réservé (validé)
          </div>
          <div class="text-line">
            <div class="body-2">
              {{ reserveValideeTotal() | numberSig }}
            </div>
            <div class="caption on-background-alt">{{ unite() }}</div>
          </div>
        </div>
      }

      @if (reserveDraftTotal() > 0) {
        <div class="text-line justify-between"
             matTooltip="Quantité réservée par des pré-prépas en brouillon (non engagée, ne décompte pas le stock dispo)">
          <div class="caption on-background-alt">
            Réservé (brouillon)
          </div>
          <div class="text-line">
            <div class="body-2 on-warning">
              {{ reserveDraftTotal() | numberSig }}
            </div>
            <div class="caption on-background-alt">{{ unite() }}</div>
          </div>
        </div>
      }

      <vl-chips
        state="transparent"
        size="small"
        cursor="pointer"
        [iconLeft]="showReservationsDetail() ? 'expand_less' : 'expand_more'"
        (action)="showReservationsDetail.set(!showReservationsDetail())">
        {{ showReservationsDetail() ? 'Masquer' : 'Voir' }} le détail ({{ reservationsLignes().length }})
      </vl-chips>

      @if (showReservationsDetail()) {
        <div class="flex-col reservations-detail">
          @for (item of reservationsLignes(); track item.row.prepLigneId) {
            <div class="reservation-row flex-row justify-between gap-12 wrap align-center clickable"
                 matTooltip="Ouvrir la fiche commande"
                 (click)="goToCommande(item.row.commandeClientId, $event)">
              <div class="flex-col gap-0" style="min-width: 0; flex: 1 1 auto">
                <div class="caption ellipsis flex-row gap-4 align-center">
                  <strong>{{ item.row.numero }}</strong>
                  @if (item.row.tiersDenomination) {
                    <span class="on-background-alt">· {{ item.row.tiersDenomination }}</span>
                  }
                  <mat-icon class="commande-link-icon">open_in_new</mat-icon>
                </div>
                @if (item.lotNumero && (lots()?.length ?? 0) > 1) {
                  <div class="tiny on-background-alt">
                    sur lot {{ item.lotNumero }}
                  </div>
                }
              </div>
              <div class="flex-row gap-8 align-center nowrap">
                <vl-chips
                  [state]="item.row.statut === 'DRAFT' ? 'enabled' : (item.row.statut === 'OBSOLETE' ? 'disabled' : 'valid')"
                  size="tiny" cursor="default">
                  {{
                    item.row.statut === 'DRAFT' ? 'Brouillon' :
                    item.row.statut === 'VALIDEE' ? 'Validée' :
                    item.row.statut === 'CONSOMMEE_PARTIELLE' ? 'Partielle' :
                    item.row.statut === 'CONSOMMEE' ? 'Consommée' : item.row.statut
                  }}
                </vl-chips>
                <span class="caption nowrap qty-cell">
                  <strong>{{ item.row.quantiteRestante | numberSig }}</strong>
                  <span class="on-background-alt"> {{ unite() }}</span>
                </span>
              </div>
            </div>
          }
        </div>
      }
    }

    <vl-chips state="secondary" iconRight="inventory_2"
              data-testid="btn-go-inventory"
              (action)="goToInventory()">{{ 'inventaires.label' | trans }}
    </vl-chips>

    @if (infoDechargement().quantite) {
      <vl-chips state='warn' [contentHeight]="true" cursor="default">
        <div class="flex-col gap-4 w100">
          <div class="text-line justify-between">
            <div class="text-line">
              <mat-icon>move_to_inbox</mat-icon>
              <div class="body-2">
                {{ 'stock.enDechargement' | trans }}
              </div>
            </div>

            <div class="text-line">
              <div class="body-2">{{ infoDechargement().quantite | numberSig }}</div>
              <div class="caption">{{ unite() }}</div>
            </div>
          </div>

          <div class="caption">
            {{ 'stock.enDechargementInfo' | trans:{nb: infoDechargement().nbDechargements} }}
          </div>
        </div>
      </vl-chips>
    }

    @if (highlightAdresseId()) {
      @for (a of primaryRecaps(); track $index) {
        <ng-container *ngTemplateOutlet="adresseChipTpl; context: {$implicit: a}"/>
      }
      @if (otherRecaps()?.length) {
        <vl-expand-button [(expanded)]="showOtherAdresses" size="small"/>
        @if (showOtherAdresses()) {
          @for (a of otherRecaps(); track $index) {
            <ng-container *ngTemplateOutlet="adresseChipTpl; context: {$implicit: a}"/>
          }
        }
      }
    } @else {
      @for (a of recap().adresses; track $index) {
        <ng-container *ngTemplateOutlet="adresseChipTpl; context: {$implicit: a}"/>
      }
    }
  </div>
}

<ng-template #adresseChipTpl let-a>
  <vl-chips state='transparent' [contentHeight]="true" cursor="default">
    <div class="flex-col gap-4 w100">

      <div class="text-line justify-between">
        <div class="body-1">
          {{ a.label }}
        </div>
        <div class="text-line">
          <div class="body-2">{{ a.total | numberSig }}</div>
          <div class="caption">{{ unite() }}</div>
        </div>
      </div>

      @if (a.stock || a.piedDeChaine || a.zoneExpedition || a.zoneNonConforme || a.zoneQuarantaine) {
        <div class="divider mb-10 mt-10"></div>
      }

      @if (a.stock) {
        <div class="text-line justify-between">
          <div class="text-line">
            <mat-icon>{{ iconFor('stock') }}</mat-icon>
            <div class="caption">{{ 'stock.label' | trans }}</div>
          </div>
          <div class="text-line">
            <div class="body-2">{{ a.stock | numberSig }}</div>
            <div class="caption">{{ unite() }}</div>
          </div>
        </div>
      }
      @if (a.piedDeChaine) {
        <div class="text-line justify-between">
          <div class="text-line">
            <mat-icon>{{ iconFor('pdc') }}</mat-icon>
            <div class="caption">{{ 'data.piedDeChaine' | trans }}</div>
          </div>
          <div class="text-line">
            <div class="body-2">{{ a.piedDeChaine | numberSig }}</div>
            <div class="caption">{{ unite() }}</div>
          </div>
        </div>
      }
      @if (a.zoneExpedition) {
        <div class="text-line justify-between">
          <div class="text-line">
            <mat-icon>{{ iconFor('expedition') }}</mat-icon>
            <div class="caption">{{ 'stock.zoneExpedition' | trans }}</div>
          </div>
          <div class="text-line">
            <div class="body-2">{{ a.zoneExpedition | numberSig }}</div>
            <div class="caption">{{ unite() }}</div>
          </div>
        </div>
      }
      @if (a.zoneNonConforme) {
        <div class="text-line justify-between">
          <div class="text-line">
            <mat-icon>{{ iconFor('nonConforme') }}</mat-icon>
            <div class="caption">{{ 'stock.zoneNonConforme' | trans }}</div>
          </div>
          <div class="text-line">
            <div class="body-2">{{ a.zoneNonConforme | numberSig }}</div>
            <div class="caption">{{ unite() }}</div>
          </div>
        </div>
      }
      @if (a.zoneQuarantaine) {
        <div class="text-line justify-between">
          <div class="text-line">
            <mat-icon>{{ iconFor('quarantaine') }}</mat-icon>
            <div class="caption">{{ 'stock.zoneQuarantaine' | trans }}</div>
          </div>
          <div class="text-line">
            <div class="body-2">{{ a.zoneQuarantaine | numberSig }}</div>
            <div class="caption">{{ unite() }}</div>
          </div>
        </div>
      }
    </div>
  </vl-chips>
</ng-template>
